import { render } from "./commonly.vue?vue&type=template&id=178f700e&scoped=true"
import script from "./commonly.vue?vue&type=script&lang=js"
export * from "./commonly.vue?vue&type=script&lang=js"

import "./commonly.vue?vue&type=style&index=0&id=178f700e&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-178f700e"]])

export default __exports__